<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">


 <ContentHeader :title="$store.state.languages.lang_phrases.yasal_uyari"  url="CreateBrand" :show_button="false" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader> 


<div class="content_card_content">







</div>





</div>







</div>
</template>
<script>
export default {

  name: 'Disclaimer',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>